import { usePrevious, useUpdateEffect } from 'react-use';

import {
   MedicalDeviceOrderAllFieldsFormBean,
   MedicalDeviceOrderFormReset,
   MedicalDeviceOrderFormWatch,
} from './medicalDeviceOrder.types';

type MedicalDeviceOrderFormRestorerProps = {
   readonly watch: MedicalDeviceOrderFormWatch;
   readonly reset: MedicalDeviceOrderFormReset;
   readonly defaultValues: Partial<MedicalDeviceOrderAllFieldsFormBean>;
};

export const MedicalDeviceOrderFormRestorer = (props: MedicalDeviceOrderFormRestorerProps): null => {
   const resetValues = props.watch(['device', 'deviceType']);

   const previousResetValues = usePrevious(resetValues);
   useUpdateEffect(() => {
      if (
         resetValues?.device &&
         previousResetValues?.device &&
         previousResetValues.device.id !== resetValues.device.id
      ) {
         props.reset({
            ...props.defaultValues,
            device: resetValues.device,
         });
      }
   }, [resetValues.device]);
   useUpdateEffect(() => {
      if (previousResetValues?.deviceType !== resetValues?.deviceType) {
         props.reset({
            ...props.defaultValues,
            deviceType: resetValues.deviceType ?? props.defaultValues.deviceType,
         });
      }
   }, [resetValues.deviceType]);
   return null;
};
